// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__9N6R_","title":"InfoRow_title__1q6-O"};